import axios from 'axios'
import { advertizerApiHost } from '../../constants/envs'
import { ISendingScheduleRepository, SendingSchedulesQuery } from '../../application/ports/ISendingScheduleRepository'
import { SendingScheduleEntity } from '../../domain/entities/SendingSchedule'
import { mapApiToEntity } from '../mappers/sendingSchedules.mapper'
import { CreateSendingScheduleRequest } from '../../shared/types/CreateSendingScheduleRequest'
import { SendingSchedule } from '../../shared/types/SendingSchedule'
import { AuthTokenProvider } from '../auth/AuthTokenProvider'

export class SendingSchedulesAxiosRepository implements ISendingScheduleRepository {
  constructor(private auth: AuthTokenProvider) {}

  private async authHeaders() {
    const token = await this.auth.getToken()
    if (!token) throw new Error('Unauthenticated')
    return { Authorization: `Bearer ${token}` }
  }

  async list(params: SendingSchedulesQuery): Promise<{ items: SendingScheduleEntity[]; page: number; perPage: number; total: number }> {
    const headers = await this.authHeaders()
    const res = await axios.get(advertizerApiHost + '/api/sending_schedules', {
      params: { page: params.page, perPage: params.perPage, search: params.search || '' },
      headers,
    })
    return {
      items: (res.data.sendingSchedules || []).map(mapApiToEntity),
      page: res.data.pagination.page,
      perPage: res.data.pagination.perPage,
      total: res.data.pagination.total,
    }
  }

  async create(payload: CreateSendingScheduleRequest): Promise<SendingSchedule> {
    const headers = await this.authHeaders()
    const res = await axios.post(advertizerApiHost + '/api/sending_schedules', payload, { headers })
    return res.data as SendingSchedule
  }

  async get(uuid: string): Promise<SendingScheduleEntity | null> {
    const headers = await this.authHeaders()
    const res = await axios.get(advertizerApiHost + '/api/sending_schedules/' + uuid, { headers })
    return res.data ? mapApiToEntity(res.data as any) : null
  }
}
